import modifyId from "./modifyId";

type StudentIdSource = {
  id?: string;
  student_id?: string;
};

/**
 * Experience owns the student ID a candidate actually sees (users.referal_code,
 * e.g. RTXSTU18920019692) and hands it over in the SSO claim. Accounts that
 * logged in before that claim existed still carry the numeric Experience id,
 * and portal-native accounts carry none at all — for those, fall back to the
 * shortened portal uuid so the column is never blank.
 */
function studentId(user?: StudentIdSource | null) {
  if (user?.student_id) return user.student_id;
  return modifyId(user?.id ?? "");
}

export default studentId;
